export function createAuthTokenManager() {
    let token = null;
    const listeners = new Set();
    function emit() {
        for (const listener of listeners) {
            listener(token);
        }
    }
    return {
        setToken(newToken) {
            token = newToken;
            emit();
        },
        getToken() {
            return token;
        },
        clearToken() {
            token = null;
            emit();
        },
        subscribe(listener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
    };
}
export const authTokenManager = createAuthTokenManager();
//# sourceMappingURL=authTokenManager.js.map